import { render, staticRenderFns } from "./TaxIncentives.vue?vue&type=template&id=71629092&scoped=true"
import script from "./TaxIncentives.vue?vue&type=script&lang=js"
export * from "./TaxIncentives.vue?vue&type=script&lang=js"
import style0 from "./TaxIncentives.vue?vue&type=style&index=0&id=71629092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71629092",
  null
  
)

export default component.exports